import * as React from "react";
import { Button, Popover, PopoverSurface, PopoverTrigger, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  buttonActive: {
    color: "var(--colorBrandForeground1)",
  },
  surface: {
    minWidth: "320px",
    maxWidth: "560px",
  },
  icon: {
    display: "block",
  },
});

export interface FilterPopoverControlProps {
  buttonLabel?: string;
  hasActiveFilters?: boolean;
  children: React.ReactNode;
}

export function FilterPopoverControl({
  buttonLabel = "Filters",
  hasActiveFilters = false,
  children,
}: FilterPopoverControlProps): JSX.Element {
  const styles = useStyles();
  const icon = (
    <svg
      className={styles.icon}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M3 5H21L14 13V20L10 22V13L3 5Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <Popover positioning="below-end">
      <PopoverTrigger disableButtonEnhancement>
        <Button
          appearance="subtle"
          className={hasActiveFilters ? styles.buttonActive : undefined}
          icon={icon}
          aria-label={buttonLabel}
          title={buttonLabel}
        />
      </PopoverTrigger>

      <PopoverSurface className={styles.surface}>{children}</PopoverSurface>
    </Popover>
  );
}